import { FromStringToDate, ToMoneyFormat } from "../../../../../utils/Helper";
import { addTableHeader, breakWord, drawBody } from "../InvoiceGeneratorUtils";

const PDF_RESMI_SURAT_JALAN = (data: any) => {
  const header = [
    {
      title: "NO",
      style: {
        width: 10,
      },
    },
    {
      title: "NAMA BARANG",
      style: {
        width: 90,
      },
    },
    {
      title: "SAT",
      style: {
        width: 30,
      },
    },
    {
      title: "HARGA",
      style: {
        width: 30,
      },
    },
    {
      title: "QTY",
      style: {
        width: 12,
      },
    },
    {
      title: "TOTAL",
    },
  ];

  const headerSuratJalan = [
    {
      title: "NO",
      style: {
        width: 10,
      },
    },
    {
      title: "NAMA BARANG",
      style: {
        width: 90,
      },
    },
    {
      title: "SAT",
      style: {
        width: 30,
      },
    },
    {
      title: "QTY",
      style: {
        width: 22,
      },
    },
  ];

  // Data Table
  const dataTable: any[] = [];
  data.invoice_detail.forEach((item: any, index: number) => {
    let temp: any[] = [];
    const total = item.price * item.quantity;
    temp.push(index + 1); // No
    temp.push(item?.product?.name || "-"); // Nama Barang
    temp.push(item.unit_type); // Satuan
    temp.push(ToMoneyFormat(item?.price)); // Harga
    temp.push(item?.quantity); // Qty
    temp.push(ToMoneyFormat(Math.round(total) || "0")); // Total
    dataTable.push(temp);
    temp = [];
  });

  // Data Table Surat Jalan
  const dataTableSuratJalan: any[] = [];
  data.invoice_detail.forEach((item: any, index: number) => {
    let temp: any[] = [];
    temp.push(index + 1); // No
    temp.push(item?.product?.name || "-"); // Nama Barang
    temp.push(item.unit_type); // Satuan
    temp.push(item?.quantity); // Qty
    dataTableSuratJalan.push(temp);
    temp = [];
  });

  // Minimum Rows Data Invoice & Surat Jalan
  for (let i = dataTable.length; i < 12; i++) {
    let temp: any[] = [];
    temp.push(" ");
    dataTableSuratJalan.push(temp);
    dataTable.push(temp);
  }

  const print = (doc: any) => {
    // Variable
    const docWidth = doc.internal.pageSize.width;
    const docHeight = doc.internal.pageSize.height;
    const currentHeight = 15;
    const colorBlack = "#000000";
    const colorGray = "#4d4e53";
    const fieldTextSize = 10;
    const subLineHeight = 4;
    const tdWidth = (doc.getPageWidth() - 20) / header.length;
    const headerTextSize = 20;
    const labelTextSize = 12;
    const lineHeight = 6;

    let pdfConfig = {
      docWidth,
      docHeight,
      currentHeight,
      colorBlack,
      colorGray,
      fieldTextSize,
      subLineHeight,
      header,
      dataTable,
      tdWidth,
      headerTextSize,
      labelTextSize,
      lineHeight,
    };

    // Header Invoice
    doc.setFontSize(pdfConfig.headerTextSize);
    doc.setTextColor(pdfConfig.colorBlack);
    doc.text(10, currentHeight, "CV. TUNAS JAYA TEKNIK");
    doc.setFontSize(12);
    doc.text(
      pdfConfig.docWidth - 9,
      pdfConfig.currentHeight,
      `Tanggal : ${FromStringToDate(data?.invoice_date || "")} `,
      "right"
    );
    doc.setFontSize(pdfConfig.fieldTextSize);
    pdfConfig.currentHeight += 5;
    doc.text(10, pdfConfig.currentHeight, "JL DR.RAJIMAN NO. 230 SOLO 57151");
    pdfConfig.currentHeight += 5;
    doc.text(10, pdfConfig.currentHeight, "087812293649");
    doc.setFontSize(12);
    pdfConfig.currentHeight += breakWord(
      data?.customer_name || "",
      doc,
      pdfConfig.currentHeight - 4,
      pdfConfig.docWidth - 12
    );
    if (data?.pre_order_number) {
      doc.text(
        pdfConfig.docWidth - 12,
        pdfConfig.currentHeight,
        data?.pre_order_number || "",
        "right"
      );
      pdfConfig.currentHeight += 5;
    } else {
      pdfConfig.currentHeight += 2;
    }
    doc.setFontSize(pdfConfig.fieldTextSize);
    doc.setFontSize(17);
    doc.text(
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight + 2,
      `# ${data.invoice_number}`,
      "right"
    );
    doc.setFontSize(12);
    doc.setTextColor(pdfConfig.colorBlack);
    doc.text(10, pdfConfig.currentHeight + 2, `INVOICE`);
    doc.setFontSize(pdfConfig.fieldTextSize);
    doc.setTextColor(pdfConfig.colorGray);
    pdfConfig.currentHeight += pdfConfig.subLineHeight;
    doc.line(
      10,
      pdfConfig.currentHeight,
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight
    );
    pdfConfig.currentHeight += 1;

    // Table Header
    doc.setFontSize(pdfConfig.fieldTextSize);
    addTableHeader({ doc: doc, config: pdfConfig });
    doc.line(
      10,
      pdfConfig.currentHeight,
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight
    );

    // Table Body
    doc.setFontSize(pdfConfig.fieldTextSize + 1);
    drawBody({ doc: doc, config: pdfConfig });
    doc.line(
      10,
      pdfConfig.currentHeight,
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight
    );

    // Footer Invoice Left Side
    doc.setFontSize(11);
    pdfConfig.currentHeight += pdfConfig.lineHeight;
    doc.text(
      10,
      pdfConfig.currentHeight,
      "SELURUH TRANSAKSI HARAP DIBAYARKAN FULL AMOUNT"
    );
    doc.setFontSize(11);
    pdfConfig.currentHeight += 6;
    doc.text(10, pdfConfig.currentHeight, "TERMIN PEMBAYARAN :");
    pdfConfig.currentHeight += 6;
    doc.text(10, pdfConfig.currentHeight, `PEMBAYARAN VIA TRANSFER BANK BCA`);
    pdfConfig.currentHeight += 6;
    doc.text(10, pdfConfig.currentHeight, `NO REK: 7851222000`);
    pdfConfig.currentHeight += 6;
    doc.text(10, pdfConfig.currentHeight, `AN. TUNAS  JAYA TEKNIK CV`);
    pdfConfig.currentHeight += 6;
    doc.text(10, pdfConfig.currentHeight, "NOTE: ..........................");
    pdfConfig.currentHeight += 15;

    // Footer Invoice Right Side
    pdfConfig.currentHeight = pdfConfig.currentHeight - 44;

    //DPP
    doc.setFontSize(12);
    doc.text(
      pdfConfig.docWidth / 1.2,
      pdfConfig.currentHeight,
      "DPP:",
      "right"
    );
    doc.text(
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight,
      `${ToMoneyFormat(data?.total)}`,
      "right"
    );

    //TAX
    pdfConfig.currentHeight += 5;
    doc.text(
      pdfConfig.docWidth / 1.2,
      pdfConfig.currentHeight,
      "TAX:",
      "right"
    );
    doc.text(
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight,
      `${Math.round(data?.tax || 0)}`,
      "right"
    );

    //PPH
    pdfConfig.currentHeight += 6;
    doc.text(
      pdfConfig.docWidth / 1.2,
      pdfConfig.currentHeight,
      "PPH:",
      "right"
    );
    doc.text(
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight,
      `${ToMoneyFormat(Math.round(data?.pph || 0))}`,
      "right"
    );

    //TOTAL
    pdfConfig.currentHeight += 6;
    doc.text(
      pdfConfig.docWidth / 1.2,
      pdfConfig.currentHeight,
      "TOTAL:",
      "right"
    );
    doc.text(
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight,
      `${ToMoneyFormat(Math.round(data?.grand_total || 0))}`,
      "right"
    );

    // ========================================================
    doc.setFontSize(11);
    pdfConfig.currentHeight += 6;
    doc.text(
      pdfConfig.docWidth - 9,
      pdfConfig.currentHeight,
      "TOTAL PACKING, NOTA, & TGL PACKING :",
      "right"
    );
    pdfConfig.currentHeight += 6;
    doc.text(
      pdfConfig.docWidth - 9,
      pdfConfig.currentHeight,
      "......................................",
      "right"
    );

    // Invoice Tanda Terima
    doc.setFontSize(pdfConfig.fieldTextSize);
    pdfConfig.currentHeight += 15;
    doc.text(10, pdfConfig.currentHeight, "PENERIMA,");
    doc.line(
      10,
      pdfConfig.currentHeight + 15,
      50,
      pdfConfig.currentHeight + 15
    );
    doc.text(
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight,
      "HORMAT KAMI,",
      "right"
    );
    doc.line(
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight + 15,
      pdfConfig.docWidth - 50,
      pdfConfig.currentHeight + 15
    );

    // Surat Jalan Extra
    pdfConfig = {
      docWidth,
      docHeight,
      currentHeight: pdfConfig.currentHeight,
      colorBlack,
      colorGray,
      fieldTextSize,
      subLineHeight,
      header: headerSuratJalan,
      dataTable: dataTableSuratJalan,
      tdWidth,
      headerTextSize,
      labelTextSize,
      lineHeight,
    };
    pdfConfig.currentHeight += 25;
    doc.setFontSize(pdfConfig.headerTextSize);
    doc.setTextColor(pdfConfig.colorBlack);
    doc.text(10, pdfConfig.currentHeight, "CV. TUNAS JAYA TEKNIK");
    doc.setFontSize(12);
    doc.text(
      pdfConfig.docWidth - 9,
      pdfConfig.currentHeight,
      `TANGGAL : ${FromStringToDate(data?.invoice_date || "")} `,
      "right"
    );
    doc.setFontSize(pdfConfig.fieldTextSize);
    pdfConfig.currentHeight += 5;
    doc.text(10, pdfConfig.currentHeight, "JL DR.RAJIMAN NO. 230 SOLO 57151");
    pdfConfig.currentHeight += 5;
    doc.text(10, pdfConfig.currentHeight, "087812293649");
    doc.setFontSize(12);
    pdfConfig.currentHeight += breakWord(
      data?.customer_name || "",
      doc,
      pdfConfig.currentHeight - 4,
      pdfConfig.docWidth - 12
    );
    pdfConfig.currentHeight += 3;
    if (data?.pre_order_number) {
      doc.text(
        pdfConfig.docWidth - 12,
        pdfConfig.currentHeight,
        data?.pre_order_number || "",
        "right"
      );
      pdfConfig.currentHeight += 5;
    } else {
      pdfConfig.currentHeight += 2;
    }
    doc.setFontSize(pdfConfig.fieldTextSize);
    doc.setFontSize(17);
    doc.text(
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight + 2,
      `# ${data.invoice_number}`,
      "right"
    );
    doc.setFontSize(12);
    doc.setTextColor(pdfConfig.colorBlack);
    doc.text(10, pdfConfig.currentHeight + 2, `SURAT JALAN`);
    doc.setFontSize(pdfConfig.fieldTextSize);
    doc.setTextColor(pdfConfig.colorGray);
    pdfConfig.currentHeight += pdfConfig.subLineHeight;
    doc.line(
      10,
      pdfConfig.currentHeight,
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight
    );
    pdfConfig.currentHeight += 1;

    // Table Header
    addTableHeader({
      doc: doc,
      config: pdfConfig,
    });
    doc.line(
      10,
      pdfConfig.currentHeight,
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight
    );

    // Table Body
    doc.setFontSize(pdfConfig.fieldTextSize + 1);
    drawBody({
      doc: doc,
      config: pdfConfig,
    });
    doc.line(
      10,
      pdfConfig.currentHeight,
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight
    );

    // Invoice Tanda Terima
    doc.setFontSize(pdfConfig.fieldTextSize);
    pdfConfig.currentHeight += 21;
    doc.text(10, pdfConfig.currentHeight, "PENERIMA,");
    doc.line(
      10,
      pdfConfig.currentHeight + 15,
      50,
      pdfConfig.currentHeight + 15
    );
    doc.text(
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight,
      "HORMAT KAMI,",
      "right"
    );
    doc.line(
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight + 15,
      pdfConfig.docWidth - 50,
      pdfConfig.currentHeight + 15
    );
  };

  return { print };
};

export { PDF_RESMI_SURAT_JALAN };
